import React from "react";
import styled from "styled-components";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import { Tooltip } from "@mui/material";
import Balota from "../../../components/game/Balota";
import InputGameSquares from "./InputGameSquares";
import Resultado from "./Resultado";

const GanacolCard = ({ result, game, confirmHit, handleOpen, setCodeWin, ballot, setBallot, ValidBall, PlayGame }) => {
  return (
    <Card>
      {/* Fila superior */}
      {/* <TopRow>
        {Array.from({ length: 6 }).map((_, i) => (
          <BallWrap key={i}>
            <Balota move="$" classHit="class1" />
          </BallWrap>
        ))}
      </TopRow> */}
      <Resultado result={result} game={game} confirmHit={confirmHit} handleOpen={handleOpen} setCodeWin={setCodeWin} />

      {/* Cajas + auto */}
      <MiddleRow>
        <InputGameSquares
          ballot={ballot}
          setBallot={setBallot}
          ValidBall={ValidBall}
          disabled={false}
        />
      </MiddleRow>

      {/* CTA */}
      <CtaRow>
        <DemoBtn type="button" onClick={() => {PlayGame()}}>Jugar</DemoBtn>
      </CtaRow>
    </Card>
  );
};

export default GanacolCard;

/* ===================== styled-components ===================== */

const Card = styled.div`
  /* Más compacta */
  width: min(620px, 92vw);
  background: #eceef1;
  border-radius: 22px;
  padding: 18px 18px 16px;

  /* Sombra suave tipo “panel” */
  box-shadow: 0 14px 26px rgba(0, 0, 0, 0.18);

  display: flex;
  flex-direction: column;
  gap: 14px;

  @media (max-width: 600px) {
    width: min(520px, 94vw);
    padding: 16px 14px 14px;
    border-radius: 18px;
    gap: 12px;
  }
`;

const TopRow = styled.div`
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: clamp(8px, 2vw, 14px);
  align-items: center;
`;

const BallWrap = styled.div`
  /* obliga a ser cuadrado y centrado */
  width: 100%;
  aspect-ratio: 1 / 1;
  max-width: 74px; /* controla tamaño en desktop */
  justify-self: center;
  display: grid;
  place-items: center;

  /* “look” redondo por si Balota no lo aplica */
  border-radius: 999px;

  /* Si Balota renderiza IMG/SVG/DIV internos, los forzamos */
  & > * {
    width: 100% !important;
    height: 100% !important;
    border-radius: 999px !important;
  }

  /* Si dentro hay img o svg */
  img,
  svg {
    width: 100% !important;
    height: 100% !important;
    border-radius: 999px !important;
    object-fit: contain;
    display: block;
  }

  @media (max-width: 600px) {
    max-width: 58px; /* más pequeño en móvil */
  }
`;

const MiddleRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 12px;
  align-items: center;

  @media (max-width: 600px) {
    gap: 10px;
  }
`;

const Boxes = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 10px;

  .box {
    height: 62px;
    border-radius: 6px;
    background: #ffffff;
    border: 3px solid #1a1d28;
  }

  @media (max-width: 600px) {
    gap: 8px;
    .box {
      height: 56px;
      border-width: 3px;
    }
  }
`;

const AutoBtn = styled.button`
  width: 54px;
  height: 54px;
  border: 0;
  border-radius: 10px;
  cursor: pointer;

  background: #743fe3;
  color: #ffffff;

  display: grid;
  place-items: center;

  box-shadow: 0 10px 18px rgba(0, 0, 0, 0.18);
  transition: transform 0.12s ease, filter 0.12s ease;

  svg {
    font-size: 28px;
  }

  &:hover {
    filter: brightness(1.06);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0px);
  }

  @media (max-width: 600px) {
    width: 50px;
    height: 50px;
    svg {
      font-size: 26px;
    }
  }
`;

const CtaRow = styled.div`
  margin-top: 2px;
`;

const DemoBtn = styled.button`
  width: 100%;
  height: 62px;
  border: 0;
  border-radius: 12px;
  cursor: pointer;

  background: #743fe3; /* morado del diseño */
  color: #ffffff;

  font-weight: 800;
  font-size: 1.35rem;
  letter-spacing: 0.02em;

  box-shadow: 0 14px 20px rgba(0, 0, 0, 0.2);
  transition: transform 0.12s ease, filter 0.12s ease;

  &:hover {
    filter: brightness(1.06);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0px);
  }

  @media (max-width: 600px) {
    height: 58px;
    font-size: 1.18rem;
  }
`;
